module.exports = __webpack_public_path__ + "img/photo.9522a414.png";